(function () {
  function initScroller(root) {
    if (root.dataset.cfsReady === 'true') return;
    root.dataset.cfsReady = 'true';

    var track = root.querySelector('[data-cfs-track]');
    var previous = root.querySelector('[data-cfs-prev]');
    var next = root.querySelector('[data-cfs-next]');
    if (!track) return;

    function step() {
      var item = track.querySelector(':scope > *');
      return item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
    }

    function update() {
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    if (previous) previous.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initTabs(root) {
    if (root.dataset.cfsReady === 'true') return;
    root.dataset.cfsReady = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-cfs-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cfs-panel]'));

    function activate(index, focus) {
      buttons.forEach(function (button, buttonIndex) {
        var active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
        if (active && focus) button.focus();
      });
      panels.forEach(function (panel, panelIndex) {
        var active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () { activate(index, false); });
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        activate((index + direction + buttons.length) % buttons.length, true);
      });
    });
    if (buttons.length) activate(0, false);
  }

  function initAccordion(root) {
    if (root.dataset.cfsReady === 'true') return;
    root.dataset.cfsReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cfs-accordion-item]'));
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-cfs-accordion-media-item]'));
    var mobileMedia = window.matchMedia('(max-width: 767px)');

    function setItemState(item, active) {
      var trigger = item.querySelector('[data-cfs-accordion-trigger]');
      var content = item.querySelector('[data-cfs-accordion-content]');
      var expandable = item.querySelector('[data-cfs-accordion-expandable]');
      item.classList.toggle('is-open', active);
      if (trigger) trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
      if (content) content.hidden = false;
      if (expandable) {
        expandable.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) expandable.removeAttribute('inert');
        else expandable.setAttribute('inert', '');
      }
    }

    function activate(item) {
      if (!item) return;
      var mediaTarget = item.dataset.cfsAccordionMediaTarget;
      items.forEach(function (other) {
        setItemState(other, other === item);
      });
      mediaItems.forEach(function (media) {
        var active = media.dataset.cfsAccordionMediaItem === mediaTarget;
        media.classList.toggle('is-active', active);
        media.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function collapse() {
      items.forEach(function (item) {
        setItemState(item, false);
      });
      mediaItems.forEach(function (media) {
        media.classList.remove('is-active');
        media.setAttribute('aria-hidden', 'true');
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-cfs-accordion-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        if (mobileMedia.matches && item.classList.contains('is-open')) collapse();
        else activate(item);
      });
    });

    root.addEventListener('shopify:block:select', function (event) {
      var selectedItem = event.target.closest('[data-cfs-accordion-item]');
      if (selectedItem && root.contains(selectedItem)) activate(selectedItem);
    });

    if (items.length) {
      activate(items.find(function (item) { return item.classList.contains('is-open'); }) || items[0]);
    }

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', function (event) {
        if (!event.matches && !items.some(function (item) { return item.classList.contains('is-open'); })) {
          activate(items[0]);
        }
      });
    }
  }

  function initPeek(root) {
    if (root.dataset.cfsReady === 'true') return;
    root.dataset.cfsReady = 'true';

    var track = root.querySelector('[data-cfs-track]');
    var originalSlides = track ? Array.prototype.slice.call(track.children) : [];
    var previous = root.querySelector('[data-cfs-prev]');
    var next = root.querySelector('[data-cfs-next]');
    var mobileQuery = window.matchMedia('(max-width: 767px)');
    var scrollAnimationFrame = null;
    var isAnimating = false;
    if (!track || !originalSlides.length) return;

    var cloneCount = originalSlides.length > 1 ? Math.min(2, originalSlides.length) : 0;

    originalSlides.forEach(function (slide, slideIndex) {
      slide.dataset.cfsLogicalIndex = slideIndex;
    });

    function createClone(slide, logicalIndex) {
      var clone = slide.cloneNode(true);
      clone.classList.remove('is-active', 'is-before', 'is-after', 'is-prev', 'is-next');
      clone.classList.add('is-clone');
      clone.dataset.cfsClone = 'true';
      clone.dataset.cfsLogicalIndex = logicalIndex;
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
        element.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    if (cloneCount) {
      var leadingClones = document.createDocumentFragment();
      for (var leadingIndex = originalSlides.length - cloneCount; leadingIndex < originalSlides.length; leadingIndex += 1) {
        leadingClones.appendChild(createClone(originalSlides[leadingIndex], leadingIndex));
      }
      track.insertBefore(leadingClones, originalSlides[0]);

      for (var trailingIndex = 0; trailingIndex < cloneCount; trailingIndex += 1) {
        track.appendChild(createClone(originalSlides[trailingIndex], trailingIndex));
      }
    }

    var slides = Array.prototype.slice.call(track.children);
    var initialLogicalIndex = mobileQuery.matches ? 0 : originalSlides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (initialLogicalIndex < 0) initialLogicalIndex = originalSlides.length > 2 ? 1 : 0;
    var index = cloneCount + initialLogicalIndex;

    var endSpacer = document.createElement('span');
    endSpacer.className = 'cfs-peek__end-spacer';
    endSpacer.setAttribute('aria-hidden', 'true');
    track.appendChild(endSpacer);

    function syncEndSpacer() {
      if (mobileQuery.matches) {
        endSpacer.style.flexBasis = '0px';
        return;
      }
      endSpacer.style.flexBasis = '0px';
      var lastSlide = slides[slides.length - 1];
      var sideSpace = Math.max(0, (track.clientWidth - lastSlide.clientWidth) / 2);
      var desiredMaximum = Math.max(0, lastSlide.offsetLeft - sideSpace);
      var currentMaximum = Math.max(0, track.scrollWidth - track.clientWidth);
      endSpacer.style.flexBasis = Math.ceil(Math.max(0, desiredMaximum - currentMaximum)) + 'px';
    }

    function scrollTrack(left, instant, onComplete) {
      if (scrollAnimationFrame) {
        cancelAnimationFrame(scrollAnimationFrame);
        scrollAnimationFrame = null;
      }
      var target = Math.max(0, left);
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (instant || mobileQuery.matches || reduceMotion) {
        track.scrollLeft = target;
        if (onComplete) onComplete();
        return;
      }
      var start = track.scrollLeft;
      var distance = target - start;
      if (Math.abs(distance) < 1) {
        track.scrollLeft = target;
        if (onComplete) onComplete();
        return;
      }
      var startedAt = performance.now();
      var duration = 420;
      function step(now) {
        var progress = Math.min(1, (now - startedAt) / duration);
        var eased = 1 - Math.pow(1 - progress, 3);
        track.scrollLeft = start + distance * eased;
        if (progress < 1) {
          scrollAnimationFrame = requestAnimationFrame(step);
        } else {
          scrollAnimationFrame = null;
          track.scrollLeft = target;
          if (onComplete) onComplete();
        }
      }
      scrollAnimationFrame = requestAnimationFrame(step);
    }

    function renderIndex(nextIndex, instant, onComplete) {
      index = Math.max(0, Math.min(nextIndex, slides.length - 1));
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('is-before', slideIndex < index);
        slide.classList.toggle('is-after', slideIndex > index);
        slide.classList.toggle('is-prev', slideIndex === index - 1);
        slide.classList.toggle('is-next', slideIndex === index + 1);
      });
      var slide = slides[index];
      var left = mobileQuery.matches ? slide.offsetLeft : slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;
      scrollTrack(left, instant, onComplete);
      if (previous) previous.disabled = originalSlides.length < 2;
      if (next) next.disabled = originalSlides.length < 2;
    }

    function currentLogicalIndex() {
      return parseInt(slides[index].dataset.cfsLogicalIndex, 10) || 0;
    }

    function normalizeClone(onComplete) {
      var activeSlide = slides[index];
      if (activeSlide.dataset.cfsClone !== 'true') {
        if (onComplete) onComplete();
        return;
      }

      var realIndex = cloneCount + currentLogicalIndex();
      root.classList.add('is-jumping');
      renderIndex(realIndex, true, function () {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { root.classList.remove('is-jumping'); });
        });
        if (onComplete) onComplete();
      });
    }

    function navigate(direction) {
      if (isAnimating || originalSlides.length < 2) return;
      isAnimating = true;
      renderIndex(index + direction, false, function () {
        normalizeClone(function () { isAnimating = false; });
      });
    }

    if (previous) previous.addEventListener('click', function () { navigate(-1); });
    if (next) next.addEventListener('click', function () { navigate(1); });
    slides.forEach(function (slide, slideIndex) {
      slide.addEventListener('click', function () {
        if (!mobileQuery.matches && slideIndex !== index) navigate(slideIndex < index ? -1 : 1);
      });
    });
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function () {
        var logicalIndex = currentLogicalIndex();
        isAnimating = false;
        index = cloneCount + logicalIndex;
        syncEndSpacer();
        renderIndex(index, true);
      });
    }
    window.addEventListener('resize', function () {
      var logicalIndex = currentLogicalIndex();
      isAnimating = false;
      index = cloneCount + logicalIndex;
      syncEndSpacer();
      renderIndex(index, true);
    });
    syncEndSpacer();
    renderIndex(index, true);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cfs-scroller]').forEach(initScroller);
    (scope || document).querySelectorAll('[data-cfs-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-cfs-accordion]').forEach(initAccordion);
    (scope || document).querySelectorAll('[data-cfs-peek]').forEach(initPeek);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
